module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/2cd3e62c68b5bfca3e70a2cd2d108e9b.svg";